import { render, staticRenderFns } from "./SaveImage.vue?vue&type=template&id=b4d5048c&"
import script from "./SaveImage.vue?vue&type=script&lang=js&"
export * from "./SaveImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports